import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { PopupRef } from '@local/ui-infra';

export interface AdvancedInstructionsPopupData {
  currentText: string;
  footer: string;
  maxLength: number;
  placeholder: string;
  disabled?: boolean;
}
@Component({
  selector: 'advanced-instructions-popup',
  templateUrl: './advanced-instructions-popup.component.html',
  styleUrl: './advanced-instructions-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedInstructionsPopupComponent implements OnInit {
  textContent = signal<string>('');
  popupData = signal(null);
  @Output() updateText = new EventEmitter<string>();

  constructor(private ref: PopupRef<AdvancedInstructionsPopupComponent, AdvancedInstructionsPopupData>) {}

  ngOnInit() {
    this.popupData.set(this.ref.data);
    this.textContent.set(this.popupData().currentText);
  }

  closePopup() {
    this.updateText.emit(this.textContent());
    this.ref.destroy();
  }

  onReasonTextChange($event: string) {
    this.textContent.set($event);
  }
}
